import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-new-about',
  templateUrl: './add-new-about.component.html',
  styleUrls: ['./add-new-about.component.scss']
})
export class AddNewAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
